import type { CallRequestData, CallResponse } from '../types';

/**
 * Initiates an outbound call to the user via Propertly.io
 * This calls the Cloudflare Workers API endpoint
 */
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL.replace(/\/+$/, '');

export async function initiateCall(data: CallRequestData): Promise<CallResponse> {
  try {
    // Use dedicated Cloudflare Worker for API calls
    const response = await fetch(`${API_BASE_URL}/api/initiate-call`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ 
        success: false, 
        message: `HTTP error! status: ${response.status}` 
      }));
      return errorData;
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error initiating call:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Failed to initiate call',
    };
  }
}
